import useSWRMutation from "swr/mutation";
import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

export interface SessionInvitee {
  name?: string;
  surname?: string;
  email?: string;
  role?: string;
  status?: string;
}

interface UseSessionInvitationsArgs {
  corporateId: string | number;
  editionId: string | number;
  sessionId: string | number;
  meetingId?: string | number | null;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export interface UseSessionInvitationsResult extends PaginatedListResult<SessionInvitee> {
  resend: () => Promise<any>;
  isResending: boolean;
  resendEnabled: boolean;
}

export const useSessionInvitations = ({
  corporateId,
  editionId,
  sessionId,
  meetingId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseSessionInvitationsArgs): UseSessionInvitationsResult => {
  const url =
    corporateId && (meetingId || sessionId)
      ? meetingId
        ? `${ServicesURL.invitationStatus.replace(
            ":meetingId",
            String(meetingId),
          )}?corporateId=${corporateId}`
        : `${ServicesURL.invitationStatusSession.replace(
            ":sessionId",
            String(sessionId),
          )}?corporateId=${corporateId}`
      : null;

  const list = usePaginatedList<SessionInvitee>(url, {
    page,
    pageSize,
    search,
    searchField: "name",
    fieldFilters,
  });

  const { trigger: resend, isMutating: isResending } = useSWRMutation(
    corporateId && editionId && sessionId
      ? `${ServicesURL.resendSessionNotifications
          .replace("{editionId}", String(editionId))
          .replace(
            "{sessionId}",
            String(sessionId),
          )}?corporateId=${corporateId}`
      : null,
    (u: string) => fetcher<any>(u, MethodType.POST),
  );

  const resendEnabled = list.response?.resend_enabled === true;

  return { ...list, resend, isResending, resendEnabled };
};

export const getInviteeName = (i: SessionInvitee): string =>
  [i.name, i.surname].filter(Boolean).join(" ").trim() || i.email || "-";
